// Elemento a mostrar por cada campo con error. Productos no tiene un input propio: se usa la
// primera celda en rojo de la tabla o, si no hay, el mensaje bajo la tabla.
const errorSelector = (id) =>
  id === 'materialLines' ? '#materialLines .Mui-error input, #materialLines-error' : `#${id}`;

// Lleva al primer campo con error del formulario y lo enfoca si es un input. querySelector con
// una lista de selectores devuelve la primera coincidencia en orden del DOM, que es el orden de
// lectura (y de tabulación) del formulario. Devuelve el elemento, o null si no encontró ninguno.
const scrollToFirstError = (container, errors) => {
  const ids = Object.keys(errors).filter((id) => errors[id]?.length > 0);
  if (!container || ids.length === 0) return null;
  const target = container.querySelector(ids.map(errorSelector).join(', '));
  if (!target) return null;
  // preventScroll: el foco no debe saltar de golpe y cortar el desplazamiento suave.
  target.focus({ preventScroll: true });
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return target;
};

export default scrollToFirstError;
